import { render } from "./DataTableAssignRole.vue?vue&type=template&id=32858652"
import script from "./DataTableAssignRole.vue?vue&type=script&lang=js"
export * from "./DataTableAssignRole.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/mobysuite-docs-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__